import React from "react";
import "./Common.css";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  const handleNavClick = (id) => {
    if (window.location.pathname === "/") {
      if (id === "top") {
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    } else {
      if (id === "top") {
        navigate("/");
      } else {
        navigate("/", { state: { scrollTo: id } });
      }
    }
  };

  const handleResourceClick = (category) => {
    navigate(`/resource?category=${encodeURIComponent(category)}`);
    window.scrollTo(0, 0);
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="row gy-4">
          {/* About */}
          <div className="col-lg-3 col-md-6">
            <img
              src="/images/AMBW.svg"
              alt=""
              className="footer-logo mb-4"
              onClick={() => handleNavClick("top")}
              style={{ cursor: "pointer" }}
            />

            <p className="footer-text">
              A flagship programme of the Ministry of Health & Family Welfare,
              Government of India to reduce the prevalence of anemia among key
              beneficiaries.
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-lg-3 col-md-6 d-flex flex-column align-items-center">
            <h5>Quick Links</h5>

            <ul>
              <li onClick={() => handleNavClick("top")}>Home</li>
              <li onClick={() => handleNavClick("about")}>About Us</li>
              <li onClick={() => handleNavClick("strategy")}>7x7x7 Strategy</li>
              <li onClick={() => handleNavClick("beneficiaries")}>
                Beneficiaries
              </li>
              <li onClick={() => handleNavClick("gallery")}>Gallery</li>
            </ul>
          </div>

          {/* IFA */}
          {/* <div className="col-lg-2 col-md-6">
            <h5>IFA Supplementation</h5>

            <ul>
              <li>AMB Ranking</li>
              <li>Tests and Treatments</li>
              <li>AMB Performance Indicators</li>
              <li>Stock</li>
              <li>Denominators and Numerators</li>
            </ul>
          </div> */}

          {/* Resources */}
          <div className="col-lg-3 col-md-6">
            <h5>Resources</h5>

            <ul>
              <li onClick={() => handleResourceClick("Operational Guideline")}>
                Operational Guideline
              </li>
              <li onClick={() => handleResourceClick("Guidance Note")}>
                Guidance Note
              </li>
              <li onClick={() => handleResourceClick("Training Tool Kit")}>
                Training Tool Kit
              </li>
              <li onClick={() => handleResourceClick("AMB Launch Event")}>
                AMB Launch Event
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="col-lg-3 col-md-12">
            <h5>Contact Information</h5>

            <p>
              📍 Ministry of Health & Family Welfare,
              <br />
              Government of India
            </p>

            <p>📞 011-26108983/84</p>

            <p>✉ itdivision[at]nhsrcindia[dot]org</p>

            {/* <div className="visitor-card text-center"> */}
              {/* <h6>VISITOR COUNTER</h6> */}

              {/* <div className="d-flex gap-3"> */}
                {/* <div className="counter-box">
                  <span>TOTAL</span>
                  <h3>08</h3>
                </div> */}

                {/* <div className="counter-box today">
                  <span>TODAY</span>
                  <h3>1</h3>
                </div> */}
              {/* </div> */}
            {/* </div> */}
          </div>
        </div>

        <hr />

        <div className="copyright">
          <div>
            © 2026 Anemia Mukt Bharat. All Rights Reserved. Ministry of Health &
            Family Welfare, Government of India.
          </div>

          <div className="footer-links">
            {/* <span
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/privacy-policy")}
            >
              Privacy Policy
            </span>
            <span onClick={() => navigate("/terms-of-use")} style={{ cursor: "pointer" }}>
              Terms of Use
            </span>
            <span onClick={() => navigate("/accessibility")} style={{ cursor: "pointer" }}>
              Accessibility
            </span> */}
               {/* <span> <h6>VISITOR COUNTER :</h6></span>
               <span>  <h6>08</h6> </span> */}
          </div>
       
        </div>
      </div>
    </footer>
  );
};

export default Footer;
